import { isEmpty } from 'lodash'

export const validationMessages = {
  'required': 'is required',
  'invalid': 'has an invalid format',
  'duplicated': 'is not unique'
}

export const contactsValidState = contacts => {
  const validStates = contacts.map(x => contactValidState(x))
  // also check for duplicate emails
  const emails = contacts.map(x => (x.email || x.emailAddress || '').toLowerCase())
  for (let i = 0; i < contacts.length; i++) {
    const validState = validStates[i]
    if (!validState.isValid) continue
    const contact = contacts[i]

    if (contact.hasOwnProperty('email')) {
      if (emails.filter(x => x === contact.email.toLowerCase()).length > 1) {
        validState.email = 'duplicated'
        validState.isValid = false
      }
    }

    if (contact.hasOwnProperty('emailAddress')) {
      if (emails.filter(x => x === contact.emailAddress.toLowerCase()).length > 1) {
        validState.emailAddress = 'duplicated'
        validState.isValid = false
      }
    }
  }
  return validStates
}

export const isValidContact = contact => contactValidState(contact).isValid

export function contactValidState (contact) {
  const errors = {}
  if (!contact) contact = {}

  if (!contact.firstName) errors.firstName = 'required'
  if (!contact.lastName) errors.lastName = 'required'
  if (!contact.country) errors.country = 'required'
  if (!contact.department) errors.department = 'required'

  // these differ based on SF endpoints?
  if (!contact.email && !contact.emailAddress) {
    if (contact.hasOwnProperty('email')) errors.email = 'required'
    if (contact.hasOwnProperty('emailAddress')) errors.emailAddress = 'required'
  }

  // these differ based on SF endpoints?
  if (!contact.jobTitle && !contact.title) {
    if (contact.hasOwnProperty('jobTitle')) errors.jobTitle = 'required'
    if (contact.hasOwnProperty('title')) errors.title = 'required'
  }

  // these differ based on SF endpoints?
  if (!contact.officePhone && !contact.phone) {
    if (contact.hasOwnProperty('officePhone')) errors.officePhone = 'required'
    if (contact.hasOwnProperty('phone')) errors.phone = 'required'
  }
  
  // Not needed for bulkAdd
  if (contact.hasOwnProperty('company') && !contact.company) errors.company = 'required'

  // stupid regexes; err on the side of accepting
  if (contact.email && !contact.email.match(/.+@.+\..+/i)) errors.email = 'invalid' // something@something.something
  if (contact.emailAddress && !contact.emailAddress.match(/.+@.+\..+/i)) errors.emailAddress = 'invalid' // something@something.something

  if (contact.officePhone && !contact.officePhone.match(/\d\d/)) errors.officePhone = 'invalid' // has two numbers in a row somewhere
  if (contact.phone && !contact.phone.match(/\d\d/)) errors.officePhone = 'invalid' // has two numbers in a row somewhere

  errors.isValid = isEmpty(errors)

  return errors
}
